
import { defineComponent } from 'vue';
import _ from 'lodash';
import { _Util } from '@/MyUtil';
import { _ServerApi } from '@/serverAPI';




export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
      "util" : _Util.getInstance(),
      "email": "",
    }
  },
  components: {

  },
  methods: {
    async resetPassword(){

      const util = this.util;
      const email = this.email;
      if(!util.isEamilString(this.email)){
        util.alert({
          vue_ele:this.$root,
          msg:"이메일을 정확히 입력하세요.",
          title:"안내"});
        return;
      }

      const isLogin = this.util.IsLogin(this.$cookies);
      if(isLogin){
        util.alert({
          vue_ele:this.$root,
          msg:"이미 로그인 있습니다.",
          title:"안내"});
        return;
      }

      if(!confirm(`${email} 으로 비밀번호를 이메일이 발송됩니다.`)){
        return;
      }
      const _api = _ServerApi.getInstance();
      await util.setLoading({isLoading:true,"vue_ele" : this.$root});
      const result = await _api.postJson("/api/PasswdReset", {
        "email": this.email,
      });
      await util.waitTime(800);
      await util.setLoading({isLoading:false,"vue_ele" : this.$root});

      if(result.isError){
        util.alert({msg:result.msg,title:"안내","vue_ele" : this.$root})
        return;
      }
      
      this.$router.replace("/PasswordResetResult");
      return;
    }
  },

});
